import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { MovieItems, MovieSliceState, SimilarMovie, TrailerMovie } from './MovieType'

const initialState: MovieSliceState = {
    movie: {
        cast: [{ name: '', character_name: '', url_small_image: '' }],
        torrents: [{ url: '', type: '', size: '', seeds: '', quality: '', peers: '' }],
        genres: [''],
        background_image: '',
        background_image_original: '',
        date_uploaded: '',
        date_uploaded_unix: 0,
        description_full: '',
        description_intro: '',
        download_count: 0,
        id: 0,
        imdb_code: '',
        language: '',
        large_cover_image: '',
        large_screenshot_image1: '',
        large_screenshot_image2: '',
        large_screenshot_image3: '',
        like_count: 0,
        medium_cover_image: '',
        medium_screenshot_image1: '',
        medium_screenshot_image2: '',
        medium_screenshot_image3: '',
        mpa_rating: '',
        rating: 0,
        runtime: 0,
        slug: '',
        small_cover_image: '',
        title: '',
        title_english: '',
        title_long: '',
        url: '',
        year: 0,
        yt_trailer_code: '',
    },
    trailer: [{ url: '', name: 'Промо-ролик', site: 'YOUTUBE' }],
    similar: [{ url: '', medium_cover_image: '', title_long: '' }, { url: '', medium_cover_image: '', title_long: '' },
    { url: '', medium_cover_image: '', title_long: '' }, { url: '', medium_cover_image: '', title_long: '' }],
    status: 'loading',
}

export const MovieSlice = createSlice({
    name: 'movie',
    initialState: initialState,
    reducers: {
        setMovie: (state, action: PayloadAction<MovieItems>) => {
            state.movie = action.payload
        },
        setTrailer: (state, action: PayloadAction<TrailerMovie[]>) => {
            state.trailer = action.payload
        },
        setSimilar: (state, action: PayloadAction<SimilarMovie[]>) => {
            state.similar = action.payload
        },
        setStatus: (state, action: PayloadAction<string>) => {
            state.status = action.payload
        },
    },
})

export const { setMovie, setTrailer, setSimilar, setStatus } = MovieSlice.actions;

export default MovieSlice.reducer;